import React from "react";
import { Router } from "@reach/router";
import {
  PageLayout,
  Dashboard,
} from "containers";

function App() {
  return (
    <div className="App">
      <PageLayout>
        <Router>
          <Dashboard path="dashboard" />
        </Router>
      </PageLayout>
    </div>
  );
}
export default App;
